<div class="contact-us-opacity"></div>
<div class="contact-us-container">
  <div class="title row">
    <h2>Contact Us</h2>
    <collab-comp-img-generator class="icon" imageType="icon" imageAltText="close_contact-us" (click)="onCancel()" fontClassName="icon-Close"></collab-comp-img-generator>
  </div>
  <div class="contact-us-body">
    <form *ngIf="!successfullSubmit" [formGroup]="contactUsForm">
      <div class="row">
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="name" class="formGroup__title"><span class="field_important">* </span>Full Name</label>
          <input type="text" placeholder="Enter your Name" formControlName="name" id="name" />
          <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['name'])"
            [messageConfig]="contactUsFormErrors!.name" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="email" class="formGroup__title"><span class="field_important">* </span> Email</label>
          <input type="text" placeholder="Enter your Email" formControlName="email" id="email" />
          <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['email'])"
            [messageConfig]="contactUsFormErrors!.email" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
      </div>

      <div class="row">
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="contactNumber" class="formGroup__title"><span class="field_important">* </span>Contact Number</label>
          <input type="text" placeholder="Enter your Contact Number" formControlName="contactNumber"
            id="contactNumber" />
            <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['contactNumber'])"
            [messageConfig]="contactUsFormErrors!.contactNumber" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="productName"><span class="field_important">* </span> Product Name</label>
          <select *ngIf="productNamesList" id="productName" formControlName="productName" (change)="selectTestType()">
            <option value="" disabled>Select Product Name</option>
            <option *ngFor="let item of this.productNamesList; let i = index" value="{{ item['productId'] }}">
              {{ item['productName'] }}
            </option>
          </select>
          <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['productName'])"
            [messageConfig]="contactUsFormErrors!.productName" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
      </div>
      <div class="row">
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="categoryName"><span class="field_important">* </span> Category Name</label>
          <select *ngIf="categoryNamesList" id="categoryName" formControlName="categoryName"
            (change)="selectTestType()">
            <option value="" disabled>Select Category Name</option>
            <option *ngFor="let item of this.categoryNamesList; let i = index" value="{{ item['categoryId'] }}">
              {{ item['categoryName'] }}
            </option>
          </select>
          <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['categoryName'])"
            [messageConfig]="contactUsFormErrors!.categoryName" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
      </div>

      <div class="row product">
        <label for="attach_file">Attach Files</label>
      </div>

      <div class="row">
        <div class="input_row">
          <div class="input__fileUpload" fileDragDrop (onFileDropped)="uploadFile($event)" *ngIf="filesUploadedData.length === 0">
            <input hidden type="file" id="fileDragDrop" #fileInput multiple accept="{{ acceptedFileType }}"
              (change)="uploadFile($event.target!['files'])"/>
            <ng-container>
              <collab-comp-button type="button" class="browse-files file_button" [buttonConfig]="browseButtonConfig"
                (onBtnClick)="fileInput.click()"></collab-comp-button>
            </ng-container>
          </div>
          <span class="no_file" *ngIf="filesUploadedData.length === 0">Choose File</span>
          <div class="" *ngIf="filesUploadedData.length > 0">
            <div class="row document">
              <!-- <collab-comp-img-generator (click)="deleteAttachment()" imageType="image" imgUrl="assets/icons/file2.svg" altText="delete file"></collab-comp-img-generator> -->
              <span>{{
                filesUploadedData && filesUploadedData[0].documentName
                }}</span>
              <collab-comp-img-generator (click)="deleteAttachment()" imageType="image" imgUrl="assets/icons/delete.svg" altText="delete file"></collab-comp-img-generator>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf='isFileType'>
        <app-form-inline-error [errors]="errorType"  [isSubmitted]="isFormSubmitted"></app-form-inline-error> 
      </div>
      <div class="row" *ngIf="isMaxSizeExceeded">
        <app-form-inline-error [errors]="error"  [isSubmitted]="isFormSubmitted"></app-form-inline-error>
      </div>
      <div class="row message_box">
        <div class="container__input--stacked margin__bottom--50 product">
          <label for="message" class="formGroup__title"><span class="field_important">* </span> Message</label>
          <textarea id="message" name="w3review" rows="4" cols="50" placeholder="Enter your Message"
            formControlName="message" id="message">
          </textarea>
          <app-form-inline-error class="inline" [errorControlName]="convertToFormControl(contactUsForm!.controls['message'])"
            [messageConfig]="contactUsFormErrors.message" [isSubmitted]="isFormSubmitted"></app-form-inline-error>
        </div>
      </div>
    </form>

    <div *ngIf="successfullSubmit" class="success-body">
      <collab-comp-img-generator class="icon" (click)="onCancel()" fontClassName="icon-Success text--success icon--xxxl"></collab-comp-img-generator>
      <h3 class="h3_font">Thank you for contacting us!</h3>
      <p>We have received your message, Someone from our team will get back to you shortly...</p>
    </div>
  </div>
  <div class="title_button">
    <collab-comp-button type="button" *ngIf="!successfullSubmit" class="submit-button"
      [buttonConfig]="submitButtonConfig" (onBtnClick)="submitContactUs()"></collab-comp-button>
    <collab-comp-button type="button" *ngIf="!successfullSubmit" class="submit-button" [buttonConfig]="okButtonConfig"
      (onBtnClick)="onCancel()"></collab-comp-button>
    <collab-comp-button type="button" *ngIf="successfullSubmit" class="submit-button"
      [buttonConfig]="okSecondaryButtonConfig" (onBtnClick)="onCancel()"></collab-comp-button>
  </div>
</div>
